<template lang="pug">
  grid(
    :name='$t("Payments")',
    desc='Manage Invoices & Payments'
    search
    search-placeholder='Invoices'
    :views='false'
    :sort='{ DueDateWithin: "asc", DueDateWithinFormatted: "asc" }'
    :endpoint='api.$.invoice.list.$'
    :screen='api.$.invoice.list.sentCta'
    alias='PaymentInvoiceList_SentActionPayment'
    legacy
    :tabs='tabs'
    :row-classes='rowClasses'
    fit-columns
    footer
    @selectedRows='rowSelected'
    ref='grid'
  )
    span(slot='selectionButtons')
      remit-payment(
        :rows='selectedRows'
      )
      edit-invoice-for-supplier(
        :rows='selectedRows',
        fromPage='action-required'
      )
</template>

<script>

import Grid from '@/components/Grid'
import model from './model.js'
import tabs from '@/components/_modules/Invoices/tabs'

import RemitPayment from '@/components/_modules/Invoices/actions/remit-payment'
import EditInvoiceForSupplier from '@/components/_modules/Invoices/actions/edit-invoice'

export default {
  components: {
    Grid,
    RemitPayment,
    EditInvoiceForSupplier
  },

  data() {
    return {
      model,
      tabs: tabs.tabs,
      rowClasses: {
        'negative-amount': params => (params.data || {}).TotalAmount < 0
      },
      selectedRows: [],
      selectedAll: null
    }
  },

  activated() {
    this.$refs.grid.refreshGrid()
  },

  methods: {
    rowSelected(event) {
      if (typeof event !== 'boolean') {
        this.selectedRows = event
      } else {
        this.selectedAll = event
        this.selectedRows = []
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import "~@/assets/sass/_variables.scss";
@import "~@/components/_modules/Invoices/statuses.scss";

.grid >>> {
  .ag-row.negative-amount {
    @include theme {
      background-color: lighten(v(urgent-02), 45%);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Invoice-sent-cta/index.vue